declare const $$epiforms: any;

class AANSubscribe {
	init() {
		if (typeof $$epiforms === "undefined") {
			return;
		}

		$$epiforms(".EPiServerForms[data-f-metadata=\"subscribe\"]").on("formsSubmitted", (event: Event) => {
			const subscribeForm: HTMLFormElement = event.currentTarget as HTMLFormElement;
			const previousElement: HTMLElement = subscribeForm.previousElementSibling as HTMLElement;
			const nextElement: HTMLElement = subscribeForm.nextElementSibling as HTMLElement;
			
			previousElement.style.display = "none";
			nextElement.style.display = "block";
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const subscribe = new AANSubscribe();

	subscribe.init();
});
